import { Trans } from "@lingui/react";
import { Button } from "@warp-ds/elements/react/button";
import { useValidDealerItemContext } from "../../context/DealerItemProviderContext.tsx";

/** The email the message is sent from, with a link to change it in the profile. */
export const ProfileEmail = () => {
  const {
    external: { userEmail },
  } = useValidDealerItemContext();

  return (
    <div className="mt-8">
      {userEmail && (
        <p data-testid="profile-email">
          <span className="font-bold">
            <Trans
              id="dealer.contactForm.email.label"
              message="Your email address:"
              comment="Bold label in the contact forms, followed by the email address from the user's profile"
            />
          </span>{" "}
          {userEmail}
        </p>
      )}
      <Button variant="link" href="/my-page/my-account" target="_blank">
        <span className="text-xs">
          <Trans
            id="dealer.contactForm.profileLink"
            message="You can change this email address in your profile."
            comment="Link to the user's profile, shown below the email address in the contact forms"
          />
        </span>
      </Button>
    </div>
  );
};
